import React from 'react';
import { Link } from 'react-router-dom';
import ZanifyLogo from '../assets/images/zanifylogo.png';
import NewsletterSignup from './NewsletterSignup';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className='bg-deep-navy'>
      <div className="container">
        <div className="footer-content">
          <div className="footer-column">
            <h3>ZIRAYA Institute</h3>
            <p>ZIRAYA Institute is a specialized research and advocacy entity operating at the intersection of AI, neurodivergence,
              African women & AI futures, safeguarding across creative and corporate sectors, and the African creative economy.  </p>
            <p> ZIRAYA Institute is supported by Mpenzi Mashini Limited.</p>
          </div>

          <div className="footer-column">
            <h3>Quick Links</h3>
            <ul className="footer-links">
              <li><Link to="/about">About</Link></li>
              <li><Link to="/projects">Projects</Link></li>
              <li><Link to="/research-journal">Research Journal</Link></li>
              <li><Link to="/workshops-and-training">Workshops & Training</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="footer-column">
            <h3>Contact</h3>
            <p>Email: <a href="mailto:projects@zirayainstitute.org">projects@zirayainstitute.org</a> &nbsp; /  <br />
              <a href="mailto:partnerships@zirayainstitute.org">partnerships@zirayainstitute.org</a>
            </p>

            <p>Ziraya Institute IG: &nbsp; <a href="https://www.instagram.com/zirayainstitut" 
              target='_blank' rel="noopener noreferrer">@zirayainstitut</a><br/>

            Ziraya Events: &nbsp; <a href="https://www.instagram.com/zirayaevents" 
              target='_blank' rel="noopener noreferrer">@zirayaevents</a><br/>

            Fichua Pazia: &nbsp; <a href="https://www.instagram.com/fichua.pazia" 
              target='_blank' rel="noopener noreferrer">@fichua.pazia</a><br/>

           </p>

            <div className="social-links">
              <a
                href="https://www.instagram.com/zirayainstitut"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                title="Instagram"
              >
                <i className="fab fa-instagram"></i>
              </a>

              <a
                href="https://www.linkedin.com/in/valentinezikki"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                title="LinkedIn"
              >
                <i className="fab fa-linkedin-in"></i>
              </a>

              <a
                href="https://www.tiktok.com/@msichanawaai?_r=1&_t=ZS-94PySPPnYVV"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="TikTok"
                title="TikTok"
              >
                <i className="fab fa-tiktok"></i>
              </a>

              <a
                href="https://x.com/MsichanawaAi"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="X (Twitter)"
                title="X (Twitter)"
              >
                <i className="fab fa-twitter"></i>
              </a>

              <a
                href="https://youtu.be/HexqLdALlQk?si=Qu6czC5gYL7zKYtq"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="YouTube"
                title="YouTube"
              >
                <i className="fab fa-youtube"></i>
              </a>
            </div>
          </div>

          <div className="footer-column">

            <NewsletterSignup variant="compact" />
          </div>
        </div>

        <div className="footer-bottom">
          <div className="copyright">
            <p>&copy; {currentYear} Mpenzi Mashini Limited. All rights reserved.</p>
          </div>

          <div className="made-by-zanify">
            <a
              href="https://zanifytech.com"
              target="_blank"
              rel="noopener noreferrer"
              className="zanify-credit"
            >
              <span className="credit-text">Website Made by</span>
              <div className="zanify-logo-container">
                <img
                  src={ZanifyLogo}
                  alt="Zanify Technologies"
                  className="footer-zanify-logo"
                />
              </div>
            </a>
          </div>

          <div className="footer-bottom-links">
            <Link to="/privacy">Privacy Policy</Link>
            <span className="separator">|</span>
            <Link to="/terms">Terms of Use</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;